import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src755878744/src/bacha-ai-frontend/components/HomeCTAs.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src755878744/src/bacha-ai-frontend/components/ProductCards.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src755878744/src/bacha-ai-frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src755878744/src/bacha-ai-frontend/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src755878744/src/bacha-ai-frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src755878744/src/bacha-ai-frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
